/* zeroLabs Startseite: Bekannt aus (sections/zl-start-bekannt.liquid). Nur Antwort auf Antippen, nichts läuft von selbst.
   - Stimmen: Ein Absender wird gewählt, darunter steht, worum es in seinem Bericht ging. Mit der Tastatur wechseln die Pfeiltasten nach links und rechts.
   - Bierdeckel: Antippen dreht den Deckel um, nochmal tippen dreht zurück. */
(() => {
  const einrichten = (box) => {
    if (box.dataset.zlBaFertig) return;
    box.dataset.zlBaFertig = '1';

    const knoepfe = [...box.querySelectorAll('.zl-ba-stimmen__knopf')];
    const saetze = [...box.querySelectorAll('.zl-ba-stimmen__satz')];
    const waehlen = (i, perTaste) => {
      knoepfe.forEach((k, j) => {
        const an = j === i;
        k.setAttribute('aria-selected', String(an));
        k.tabIndex = an ? 0 : -1;
      });
      saetze.forEach((s, j) => {
        const an = j === i;
        if (an && s.hidden) { s.classList.remove('is-kommt'); void s.offsetWidth; s.classList.add('is-kommt'); }
        s.hidden = !an;
        s.classList.toggle('is-aktiv', an);
      });
      if (perTaste) knoepfe[i].focus(); // Fokus nur bei Bedienung mit der Tastatur verschieben (CLAUDE.md)
    };
    knoepfe.forEach((k, i) => {
      k.addEventListener('click', () => waehlen(i, false));
      k.addEventListener('keydown', (e) => {
        const n = knoepfe.length;
        if (e.key === 'ArrowRight') { e.preventDefault(); waehlen((i + 1) % n, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); waehlen((i - 1 + n) % n, true); }
      });
    });

    box.querySelectorAll('.zl-ba-deckel__deckel').forEach((d) => {
      d.addEventListener('click', () => {
        const um = d.getAttribute('aria-pressed') !== 'true';
        d.setAttribute('aria-pressed', String(um));
        d.querySelector('.zl-ba-deckel__vorn').setAttribute('aria-hidden', String(um));
        d.querySelector('.zl-ba-deckel__hinten').setAttribute('aria-hidden', String(!um));
      });
    });
  };
  const start = () => document.querySelectorAll('section[data-zl-bekannt]').forEach(einrichten);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start);

  // Feste Höhen (Labor, html[data-zl-hoehe]): Zahl und Presse sind zwei Sektionen und ein Block. Fehlt ihnen zusammen Höhe,
  // liegt sie zur Hälfte über der Zahl und unter der Presse.
  const zahlSek = document.querySelector('main > .shopify-section:has(> .zl-zahl)');
  const baSek = document.querySelector('main > .shopify-section:has(> .zl-ba)');
  if (zahlSek && baSek && zahlSek.nextElementSibling === baSek) {
    const html = document.documentElement;
    const setzen = () => {
      ['oben', 'mitte', 'unten'].forEach((k) => html.style.removeProperty(`--zl-block-plus-${k}`));
      const an = html.dataset.zlHoehe && html.dataset.zlHoehe !== 'aus';
      if (!an) return;
      // Die Höhe steht als calc() im Token, gelesen wird sie an einem Messelement
      const mass = document.createElement('div');
      mass.style.cssText = 'position:absolute;visibility:hidden;height:var(--zl-block-hoehe)';
      document.body.append(mass);
      const ziel = mass.offsetHeight;
      mass.remove();
      const rest = Math.max(0, ziel - zahlSek.getBoundingClientRect().height - baSek.getBoundingClientRect().height);
      // Ein Block ohne Bild steht in beiden Lagen in der Mitte: Zahl und Presse bleiben zusammen, der Rest liegt darüber und darunter
      html.style.setProperty('--zl-block-plus-oben', `${rest / 2}px`);
      html.style.setProperty('--zl-block-plus-unten', `${rest / 2}px`);
    };
    let warte = 0;
    const bald = () => { clearTimeout(warte); warte = setTimeout(setzen, 0); };
    new MutationObserver(bald).observe(html, { attributes: true, attributeFilter: ['data-zl-hoehe', 'data-zl-block-lage', 'data-zl-schrift'] });
    if ('ResizeObserver' in window) { const ro = new ResizeObserver(bald); ro.observe(zahlSek.firstElementChild); ro.observe(baSek.firstElementChild); }
    window.addEventListener('resize', bald);
    bald();
  }
})();

/* Abstände im Kopf an der Tinte (CLAUDE.md, Abstände im Kopf an der Tinte): Zwischen zwei Zeilen im Kopf eines Blocks
   steht überall gleich viel sichtbare Luft, gemessen von der tiefsten sichtbaren Stelle der oberen Zeile (Unterlänge, wenn
   es eine gibt) bis zur höchsten der unteren (Umlaut, Oberlänge). Wert --zl-block-tinte. Ein Umlaut am Anfang („Über“)
   bekommt so mehr Abstand, ein Wort ohne Ober- und Unterlänge weniger, und für das Auge ist es überall gleich. */
(() => {
  const KOPF = '.zl-schluss__wort, .zl-schluss .zl-info__titel, .zl-schluss__text, .zl-zahl > p, .zl-ba-kapitel__wort, .zl-ba-kapitel__titel, .zl-ba-kapitel .zl-ba-satz, .zl-ba .zl-ba-kapitel__link, .zl-aw-wort, .zl-aw-titel, .zl-aw-satz, .zl-aw-link, .jdgm-carousel-title, .jdgm-all-reviews-rating-wrapper';
  const leinwand = document.createElement('canvas').getContext('2d', { willReadFrequently: true });
  const cache = new Map();
  // Tinte eines Texts in einer Schrift: wie weit sie über die Versalhöhe und unter die Grundlinie reicht (px)
  const tinte = (text, cs) => {
    const schrift = `${cs.fontWeight} ${cs.fontSize} ${cs.fontFamily}`;
    const schluessel = schrift + '|' + text;
    if (cache.has(schluessel)) return cache.get(schluessel);
    const gr = parseFloat(cs.fontSize) || 16; // token-ok: Ersatz, falls die Größe fehlt
    const c = leinwand.canvas;
    leinwand.font = schrift;
    c.width = Math.ceil(leinwand.measureText(text + 'H').width) + 20; // token-ok: Rand der Messfläche
    c.height = Math.ceil(gr * 2); // token-ok: Höhe der Messfläche
    const g = Math.ceil(gr * 1.4); // token-ok: Grundlinie mit Platz für Umlaute darüber
    const kante = (s) => {
      leinwand.clearRect(0, 0, c.width, c.height);
      leinwand.font = schrift;
      leinwand.fillText(s, 10, g); // token-ok: Rand der Messfläche
      const d = leinwand.getImageData(0, 0, c.width, c.height).data;
      let oben = -1, unten = -1;
      for (let y = 0; y < c.height; y++) {
        for (let x = 0; x < c.width; x++) if (d[(y * c.width + x) * 4 + 3] > 100) { if (oben < 0) oben = y; unten = y; break; } // token-ok: Deckkraft, ab der ein Pixel als Tinte zählt
      }
      return { oben, unten };
    };
    const t = kante(text), h = kante('H');
    const wert = { ueber: Math.max(0, h.oben - t.oben), unter: Math.max(0, t.unten - g + 1) };
    cache.set(schluessel, wert);
    return wert;
  };
  // Zeilen eines Elements: Text, Versalhöhe und Grundlinie der ersten und der letzten Zeile (Lage in der Seite)
  // Lage in Ruhe: Verschiebungen (Auftritt, Lauf der Awards) werden abgezogen, gemessen wird der Platz im Satz
  const ruhe = (e) => { let y = 0, q = e; while (q) { y += q.offsetTop; q = q.offsetParent; } return e.getBoundingClientRect().top + window.scrollY - y; };
  const zeilen = (el) => {
    const zs = [];
    const w = document.createTreeWalker(el, NodeFilter.SHOW_TEXT);
    const r = document.createRange();
    const eb = el.getBoundingClientRect(), ev = ruhe(el);
    let n;
    while ((n = w.nextNode())) {
      const p = n.parentElement;
      if (!p || !p.offsetParent || getComputedStyle(p).display === 'none') continue;
      const cs = getComputedStyle(p);
      const gr = parseFloat(cs.fontSize) || 0;
      const v = ruhe(p);
      for (let i = 0; i < n.length; i++) {
        if (!n.data[i].trim()) continue;
        r.setStart(n, i); r.setEnd(n, i + 1);
        const k = r.getBoundingClientRect();
        if (!k.height) continue;
        const oben = k.top - v;
        // Zeichen außerhalb des Elements (etwa die rollenden Ziffern der Zahl) zählen nicht
        const mitte = oben + k.height / 2;
        if (mitte < eb.top - ev - gr / 2 || mitte > eb.bottom - ev + gr / 2) continue;
        let z = zs.find((q) => Math.abs(q.oben - oben) < k.height / 2);
        if (!z) { z = { oben, text: '', cs }; zs.push(z); }
        z.text += n.data[i];
      }
    }
    zs.sort((a, b) => a.oben - b.oben);
    return zs.map((z) => {
      leinwand.font = `${z.cs.fontWeight} ${z.cs.fontSize} ${z.cs.fontFamily}`;
      const m = leinwand.measureText('H');
      const grund = z.oben + m.fontBoundingBoxAscent;
      return { ...z, grund, versal: grund - m.actualBoundingBoxAscent, ink: tinte(z.text, z.cs) };
    });
  };
  let laeuft = false;
  const stellen = () => {
    if (laeuft) return;
    laeuft = true;
    const t0 = performance.now();
    const ziel = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--zl-block-tinte')) || 0;
    if (ziel) {
      // In Durchgängen (CLAUDE.md, Rechenzeit beim Laden): erst alle Abstände zurücksetzen, dann alles messen, dann alles setzen.
      // Jeder Abstand hängt nur am Rand seiner eigenen Zeile, deshalb dürfen alle Werte auf einmal gesetzt werden.
      const gruppen = [...document.querySelectorAll('main#MainContent > .shopify-section')].map((sek) => [...sek.querySelectorAll(KOPF)].filter((e) => e.offsetParent && !e.closest('.zl-aw-titel > *, .jdgm-carousel-item')));
      gruppen.forEach((teile) => teile.forEach((e) => e.style.removeProperty('margin-top')));
      const setzen = [];
      gruppen.forEach((teile) => {
        for (let i = 1; i < teile.length; i++) {
          const a = zeilen(teile[i - 1]), b = zeilen(teile[i]);
          if (!a.length || !b.length) continue;
          const za = a[a.length - 1], zb = b[0];
          const sichtbar = (zb.versal - zb.ink.ueber) - (za.grund + za.ink.unter);
          const jetzt = parseFloat(getComputedStyle(teile[i]).marginTop) || 0;
          setzen.push([teile[i], (jetzt + ziel - sichtbar).toFixed(1) + 'px']);
        }
      });
      setzen.forEach(([e, wert]) => e.style.setProperty('margin-top', wert, 'important'));
    }
    try { performance.measure('zl-kopf-tinte', { start: t0, end: performance.now() }); } catch (e) { /* ältere Browser */ }
    laeuft = false;
  };
  let warte = 0;
  const bald = () => { clearTimeout(warte); warte = setTimeout(stellen, 50); }; // token-ok: kurz warten, bis die Größe steht
  const schnitte = document.fonts && document.fonts.load ? Promise.all(['400 16px', '500 16px'].map((f) => document.fonts.load(f + ' ' + getComputedStyle(document.body).fontFamily))) : Promise.resolve(); // token-ok: beide Schnitte der Schrift
  // Die Köpfe stehen unter dem ersten Bildschirm: gemessen wird erst, wenn die Seite steht (Ereignis load) und beide Schnitte da sind
  const geladen = new Promise((ok) => { if (document.readyState === 'complete') ok(); else window.addEventListener('load', ok, { once: true }); });
  Promise.all([schnitte.catch(() => {}), geladen]).then(() => { stellen(); window.addEventListener('resize', bald); new MutationObserver(bald).observe(document.documentElement, { attributes: true, attributeFilter: ['data-zl-schrift', 'data-zl-hoehe', 'data-zl-block-lage'] }); });
  document.addEventListener('zl:auftritt', bald);
  window.zlKopfTinte = stellen;
})();
